import {DatePickerChangeEvent} from "@progress/kendo-react-dateinputs";
import {ComboBoxChangeEvent, DropDownListChangeEvent} from "@progress/kendo-react-dropdowns";
import {
    CheckboxChangeEvent,
    Input,
    InputChangeEvent, NumericTextBox, NumericTextBoxChangeEvent,
    RadioGroupChangeEvent,
    TextAreaChangeEvent,
} from "@progress/kendo-react-inputs";
import { IFormSettingModel } from "src/interfaces/form-settings.interface";
import {
    IAgFormSixthSectionInterface
} from "../../../../../../interfaces/forms/AgForm/ag-form-sixth-section.interface";
import classes from "../../BPPForm/BPPForm.module.scss";
import { Error } from "@progress/kendo-react-labels";

interface GeneralFormType {
    formDataFields: IAgFormSixthSectionInterface | undefined;
    formSettings: IFormSettingModel | undefined;
    changeValueHandler: (
        event:
            | CheckboxChangeEvent
            | DatePickerChangeEvent
            | TextAreaChangeEvent
            | DropDownListChangeEvent
            | InputChangeEvent
            | RadioGroupChangeEvent
            | ComboBoxChangeEvent
            | NumericTextBoxChangeEvent,
        field: string,
        group: string,
        id: number
    ) => void;
}

export function AgriculturalUseLivestockExoticsWildlifeTypeByHeadTable(
    props: GeneralFormType
): JSX.Element {

    const LivestockExoticsWildlifeTypeByHeadCount = props.formDataFields?.AgriculturalUseLivestockExoticsWildlifeTypeByHead?.length;

    return (
        <table className="blue">
            <thead>
            <tr>
                <th className="step">
                    Livestock/Exotics/Wildlife
                </th>
                <th>Number of Head</th>
            </tr>
            </thead>
            <tbody>
            {props.formDataFields?.AgriculturalUseLivestockExoticsWildlifeTypeByHead?.map((item) => {
                return (
                    <tr key={item.Id}>
                        <td>
                            <Input
                                className={classes.kTextbox}
                                name={"Type"}
                                disabled={props.formSettings?.isReadOnly}
                                value={item.Type}
                                onChange={(e) =>
                                    props.changeValueHandler(
                                        e,
                                        "Type",
                                        "AgriculturalUseLivestockExoticsWildlifeTypeByHead",
                                        item.Id!
                                    )
                                }
                            />
                        </td>
                        <td>
                            <NumericTextBox
                                name={"Head"}
                                className={classes.kTextbox}
                                spinners={false}
                                disabled={props.formSettings?.isReadOnly}
                                value={item.Head}
                                onChange={(e) =>
                                    props.changeValueHandler(
                                        e,
                                        "Head",
                                        "AgriculturalUseLivestockExoticsWildlifeTypeByHead",
                                        item.Id!
                                    )
                                }
                            />
                        </td>
                    </tr>
                );
            })}
            </tbody>
            { (LivestockExoticsWildlifeTypeByHeadCount === undefined || LivestockExoticsWildlifeTypeByHeadCount === 0 )
             && <Error>This table is required!</Error>} 
        </table>
    );
}
